import React, { useEffect, useRef } from 'react';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

type CollapseProps = {
  visible: boolean;
  className?: string;
  type: 'vertical' | 'horizontal';
  children: React.ReactNode;
};
export const Collapse = (props: CollapseProps) => {
  const { className, visible, type = 'vertical', children } = props;
  const contentRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (type !== 'vertical' || !contentRef.current || !containerRef.current) {
      return;
    }

    if (visible) {
      type === 'vertical' &&
        (containerRef.current.style.height = `${contentRef.current.clientHeight}px`);
    } else {
      type === 'vertical' && (containerRef.current.style.height = '0px');
    }
  }, [visible, type]);

  useEffect(() => {
    if (type !== 'horizontal' || !contentRef.current || !containerRef.current) {
      return;
    }

    if (visible) {
      containerRef.current.style.width = `100%`;
    } else {
      containerRef.current.style.width = '0px';
    }
  }, [visible, type]);

  return (
    <div
      ref={containerRef}
      className={twMerge(
        cx('overflow-hidden transition-all duration-500 ease-in-out', className)
      )}
    >
      <div ref={contentRef} className='x-collapseable'>
        {children}
      </div>
    </div>
  );
};
